import { retailerSlice } from './reducer';

export const { setRetailer, fetchRetailerRequest, resetRetailer } = retailerSlice.actions;
